import React from "react";
import '../general/General.css';
import { Footer, Navbar, } from '../../components/shared';
import { Helmet } from "react-helmet-async";
import UserCalendar from "./UserCalendar"; // ✅ Import the new calendar view

const CalendarEvents = () => {

  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | நிகழ்வுகள்</title>
        <link rel="canonical" href="/event/calendar" />
      </Helmet>

      <div style={{ marginTop: '20px' }}>
        <UserCalendar />
      </div>
      <Footer />
    </>
  );
};

export default CalendarEvents;
